function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: 1.75,
  y1: 2.25,
  x2: 33.25,
  y2: 2.25,
  stroke: "#016B37",
  strokeWidth: 3.5,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 1.75,
  y1: 19.25,
  x2: 33.25,
  y2: 19.25,
  stroke: "#016B37",
  strokeWidth: 3.5,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 9.625,
  y1: 10.75,
  x2: 32.375,
  y2: 10.75,
  stroke: "#016B37",
  strokeWidth: 3.5,
  strokeLinecap: "round"
});

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 21,
    viewBox: "0 0 35 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.8e88ccdf.svg";
export { ForwardRef as ReactComponent };